import React, { useState, useEffect } from "react";
// import clsx from "clsx";
// import { useFormChangeHandler } from "hooks/useFormChangeHandler";
// import { useSubmitHandler } from "hooks/useSubmitHandler";
// import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// import CreatableSelect from "react-select/creatable";
import { getRequest } from "services/api";
// import { buildQueryString } from "utils/queryHelpers";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";
import { useAgent } from "contexts/v1/masterData/AgentContext";

// const animatedComponents = makeAnimated();

const AgentPenaltyForm = ({ initialData, onSuccess, onError }) => {
  const { agents } = useAgent();
  const [seasons, setSeasons] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);

  // Load agents with search using useAgent hook
  const loadAgents = async (inputValue) => {
    try {
      const response = await getRequest(`/agent?search=${inputValue}&limit=50`);
      if (response.success) {
        return response.data.map((agent) => ({
          value: agent.id,
          label: `${agent.name} (${agent.code})`,
        }));
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
      return [];
    }
  };

  // Fetch seasons
  const fetchSeasons = async () => {
    try {
      const response = await getRequest("/season");
      if (response.success) {
        const activeSeasons = response.data
          .filter((season) => season.is_active === 1)
          .map((season) => ({
            value: season.id,
            label: season.name,
          }));
        setSeasons(activeSeasons);
      }
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  useEffect(() => {
    fetchSeasons();
    if (initialData?.agent_id) {
      // Load selected agent for edit mode
      getRequest(`/agent/${initialData.agent_id}`)
        .then((response) => {
          if (response.success) {
            setSelectedAgent({
              value: response.data.id,
              label: `${response.data.name} (${response.data.code})`,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching selected agent:", error);
        });
    }
  }, [initialData]);

  // Prepare default agent options from useAgent hook
  const defaultAgentOptions = agents.data.slice(0, 10).map((agent) => ({
    value: agent.id,
    label: `${agent.name} (${agent.code})`,
  }));

  return (
    <MasterDataFormV2
      title="Agent Penalty"
      apiUrl="/agent-penalty"
      initialData={initialData}
      fields={[
        {
          name: "agent_id",
          label: "Agent",
          type: "select",
          required: true,
          loadOptions: loadAgents,
          defaultOptions: defaultAgentOptions,
          value: selectedAgent,
          placeholder: "Search and select an agent",
        },
        {
          name: "season_id",
          label: "Season",
          type: "select",
          required: true,
          options: seasons,
          placeholder: "Select a season",
        },
        {
          name: "reason",
          label: "Reason",
          type: "text",
          required: true,
          maxLength: 255,
          placeholder: "Enter penalty reason",
        },
        {
          name: "penalty_points",
          label: "Penalty Points",
          type: "number",
          required: true,
          placeholder: "Enter penalty points",
        },
        {
          name: "penalty_date",
          label: "Penalty Date",
          type: "date",
          required: true,
          defaultValue: new Date().toISOString().split('T')[0],
        },
        {
          name: "notes",
          label: "Notes",
          type: "textarea",
          required: false,
          placeholder: "Enter additional notes (optional)",
        },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default AgentPenaltyForm;
